/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');

var GetEntityNameChangeApplication = require('../services/GetEntityNameChangeApplication');
var GetAllEntityOrganizationTypes = require('../../entity-form/services/GetAllEntityOrganizationTypes');

var EntityNameChangeApplication = require('../forms/EntityNameChangeApplication');

module.exports = {
  event: 'build:amendment:entity-name-change',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();

    $.when(GetEntityNameChangeApplication(config.applicationId), GetAllEntityOrganizationTypes())
      .done(function(appData, entityOrganizationTypes) {
        var data = _.extend(appData, {
          entityOrganizationTypes: entityOrganizationTypes
        });
        defer.resolve(
          new EntityNameChangeApplication({
            isReadOnly: config.isReadOnly,
            model: new Backbone.Model(data),
            viewMode: config.viewMode,
            mode: config.mode
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
